<template>
  <v-card elevation="3" class="rounded-xl">
    <v-row class="my-0">
      <v-col cols="12">
        <v-card-title v-if="percentDif > 0 && chartValues.length > 0">
          Observations Per 1000
          <v-icon class="mdi mdi-arrow-down success--text ml-1" size="15"></v-icon>
          <span class="success--text">{{ percentDif }}%</span>
        </v-card-title>
        <v-card-title v-if="percentDif < 0 && chartValues.length > 0">
          Observations Per 1000
          <v-icon class="mdi mdi-arrow-up error--text ml-1" size="15"></v-icon>
          <span class="error--text">{{ Math.abs(percentDif) }}%</span>
        </v-card-title>
        <v-card-title v-if="percentDif === 0 && chartValues.length > 0">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                Observations Per 1000
                <v-icon class="mdi mdi-swap-vertical ml-1" size="15"></v-icon> -
              </span>
            </template>
            <span>Less than 1% change</span>
          </v-tooltip>
        </v-card-title>
        <v-alert type="info" v-if="chartValues.length === 0">No Data for selected input</v-alert>
        <v-card-title v-if="chartValues.length < 1">
          Observations Per 1000
          <v-divider class="my-2"></v-divider>
        </v-card-title>
      </v-col>
    </v-row>
    <line-chart :data="dataCollection" :options="options" :chart="'observations'" />
  </v-card>
</template>

<script>
import LineChart from '../charts/LineChart';

export default {
  components: {
    LineChart,
  },
  props: ['chartInfo', 'view'],
  data: () => ({
    dataCollection: null,
    dashboardRange: null,
    chartMonths: [],
    chartValues: [],
    lineColor: '#F9844A',
    cancelSource: null,
    loading: false,
    percentDif: 0,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      scales: {
        xAxes: [
          {
            scaleLabel: {
              display: false,
              labelString: 'Months',
            },
            gridLines: {
              color: 'rgba(61, 97, 133, 0.25)',
              display: true,
              drawBorder: false,
              drawTicks: false,
            },
            ticks: {
              padding: 10,
            },
          },
        ],
        yAxes: [
          {
            scaleLabel: {
              display: true,
              labelString: 'Observations Per 1000',
            },
            gridLines: {
              display: false,
            },
          },
        ],
      },
    },
  }),
  mounted() {
    this.getData();
  },
  methods: {
    // Get  all patients
    async getData() {
      this.chartMonths = [];
      this.chartValues = [];

      this.chartInfo.forEach((info) => {
        const value = !isNaN(((info.observations / info.membership) * 1000).toFixed(2))
          ? ((info.observations / info.membership) * 1000).toFixed(2)
          : 0;
        this.chartMonths.push(info.month);
        this.chartValues.push(value);
      });

      this.getPercentDif();
    },
    chartData() {
      this.dataCollection = {
        labels: this.chartMonths,
        datasets: [
          {
            label: 'Observations Per 1000',
            borderColor: this.lineColor,
            pointBackgroundColor: this.lineColor,
            borderWidth: 3,
            data: this.chartValues,
          },
        ],
      };
    },
    async getPercentDif() {
      // check for undefined values
      const firstVal = this.chartValues[0] ? this.chartValues[0] : 0;
      const lastVal = this.chartValues[this.chartValues.length - 1]
        ? this.chartValues[this.chartValues.length - 1]
        : 0;

      const decreaseValue = firstVal - lastVal;
      this.percentDif =
        firstVal !== 0
          ? Math.ceil((decreaseValue / firstVal) * 100)
          : Math.ceil(decreaseValue * 100);

      this.loading = false;
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
  },

  watch: {
    async chartValues() {
      this.chartData();
    },
    async chartInfo() {
      this.getData();
    },
    async dashboardRange() {
      this.$emit('dashboardRange', this.dashboardRange);
    },
  },
};
</script>

<style></style>
